// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3SpIc","rightAdornment":"Header_rightAdornment__1Jt2F"};